import React from 'react'
import style from './style.module.scss'

interface TopTitleProps { 
    text: string,
    isVisible?: boolean
}
export const TopTitle = ({text, isVisible} : TopTitleProps) => {
  return (
    <h3 className={style.topTitle}>{text}</h3>
  )
}
